import { Stack, Typography } from '@mui/material';

import LockIcon from '@mui/icons-material/Lock';

export const YellowLock = () => (
  <Stack sx={(theme) => ({
    display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%',
    bgcolor: theme.palette.secondary.main,
  })}>
    <LockIcon sx={{ fontSize: 40 }} />
    <Typography variant='subtitle1' sx={{ textAlign: 'center', mt: 1, cursor: 'pointer' }}>
      黃區會員專屬
    </Typography>
  </Stack>
)

export const RedLock = () => (
  <Stack sx={(theme) => ({
    display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%',
    bgcolor: theme.palette.error.main,
  })}>
    <LockIcon sx={{ fontSize: 40 }} />
    <Typography variant='subtitle1' sx={{ textAlign: 'center', mt: 0, cursor: 'pointer', }}>
      紅區會員專屬
    </Typography>
  </Stack>
)

export const PayLock = () => (
  <Stack sx={(theme) => ({
    display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%',
    bgcolor: theme.palette.secondary.light
  })}>
    <LockIcon sx={{ fontSize: 40 }} />
    <Typography variant='subtitle1' sx={{ textAlign: 'center', mt: 0, cursor: 'pointer', }}>
      PAY區
    </Typography>
  </Stack>
)